import React, { Component} from "react";
import { getTenant, getToken } from "../../../auth-helpers";
import {Link} from 'react-router-dom';
const conectormanagergenesys = require('../../../ServerFunctions/conectormanagergenesys.js');
export default class TenantConectorGenesysList extends Component {
constructor(props){
    super(props);
    this.state={
        conectors:[],
        user:null
    }    
}

componentDidMount(){
    var authToken = getToken();
    var thisa= this;
    var tenant=getTenant();
    conectormanagergenesys.ListGenesysConectorAdministrador(authToken,"ObtenerTodos",tenant.TenantId,function(conectors) {
        thisa.setState({
            conectors
        })
    })
}

    render() {
        var conectors=this.state.conectors;
        return (
            <>
            <div>
            <div id="cognitousers"  align="right">
                <a className="btn btn-primary" href="/conectorgenesys-add">
                    <span className="glyphicon glyphicon-plus"></span> Agregar Conector
                </a>
            </div>
            <div id="cognitousers" className="table-responsive">
            <table className="table table-striped">
            <thead>
                    <tr>
                    <th>Nombre</th>
                    <th>Tipo</th>
                    <th>Deployment ID</th>
                    </tr>
                </thead>
            <tbody>
                {
                    conectors?(
                        <>
                        {conectors.map((item, i) => {
                            return (
                                <tr key={item.conector_id}>
                                    <td>{item.nombre}</td>
                                    <td>{item.tipo}</td>
                                    <td>{item.deployment_id}</td>
                                <td>
                                    <div className="btn-group">
                                        
                                        <Link
                                        className="paddingicon" title="Edit"
                                        to={{
                                            pathname: "/conectorgenesys-edit",
                                            state: { conector: item }
                                        }}>
                                            <span className="glyphicon glyphicon-pencil"></span>
                                        </Link>
                                        <Link
                                        className="paddingicon" title="Delete"
                                        to={{
                                            pathname: "/conectorgenesys-delete",
                                            state: { conector: item }
                                        }}>
                                            <span className="glyphicon glyphicon-trash"></span>
                                        </Link>
                                    </div>
                                    </td>
                                </tr>
                            );
                        })}
                        </>
                    ):(
                        <>
                        </>
                    )
                }
            </tbody>
            </table>
            </div>
            </div>         

          </>

        );
    }
}